import { render, staticRenderFns } from "./budget-forms-data-transfer.vue?vue&type=template&id=ade05af6&scoped=true&"
import script from "./budget-forms-data-transfer.vue?vue&type=script&lang=ts&"
export * from "./budget-forms-data-transfer.vue?vue&type=script&lang=ts&"
import style0 from "./budget-forms-data-transfer.vue?vue&type=style&index=0&id=ade05af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade05af6",
  null
  
)

export default component.exports